module.exports = __webpack_public_path__ + "static/1_Heart_Aetna_logo_sm_rgb_violet-2bf0f521117147f39c61b381cfc3ddc5.png";